export default "__VITE_ASSET__65eda419__"